import {Injectable} from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {TerceroUPPasarelaProducto} from '../_models/tercero-up-pasarela-producto';

@Injectable({
  providedIn: 'root'
})
export class TerceroUpPasarelaProductoService {
  private rutServicio = AppSettings.rutServiciosTER + '/api/tercerosUPPasarelasProductos';

  constructor(private httClient: HttpClient) {
  }

  listMetodosPasarela(idTerceroUPPasarela: string) {
    return this.httClient.get(`${this.rutServicio}/listMetodosPasarela/${idTerceroUPPasarela}`).pipe(map(res => res as TerceroUPPasarelaProducto[]));
  }

  crearPasarelaVersion(registro: TerceroUPPasarelaProducto) {
    return this.httClient.post(`${this.rutServicio}/createPasareleVersion`, registro).pipe(map(res => res as TerceroUPPasarelaProducto));
  }
}
